import { render, staticRenderFns } from "./DocumentationHeader.vue?vue&type=template&id=177b9030&"
import script from "./DocumentationHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports